import { imageModel } from "./defaults";

export const flux2 = imageModel("flux-2", "Flux 2", { text: "flux-2-pro" });
